import { makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  logo: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    display: "inline-block",
    marginRight: theme.spacing(1),
  },
  big_logo: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    display: "inline-block",
  },
  wrap: {
    display: "flex",
    alignItems: "center",
  },
  cls1: {
    fill: "#fbfef7",
    strokeWidth: "0px",
  },
  cls2: {
    fill: "#032736",
    strokeWidth: "0px",
  },
  cls3: {
    fill: "#fff",
    strokeWidth: "0px",
  },
  cls4: {
    fill: "#0ea28c",
    strokeWidth: "0px",
  },
  cls5: {
    fill: "#5ad9bf",
    strokeWidth: "0px",
  },
}));

export default function Logo(props) {
  const classes = useStyles();
  return (
    <div className={classes.wrap}>
      <svg
        id="logo"
        class={classes.logo}
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 297.27 309.56"
      >
        <g id="Layer_1-2" data-name="Layer 1">
          <g>
            <circle class={classes.cls3} cx="142.9" cy="166.66" r="142.9" />
            <path
              class="cls-1"
              d="m63.52,114.23c-.03,2.51-1.61,4.1-4.1,4.1-2.59,0-4.29-1.79-4.22-4.44.06-2.27,1.78-3.93,4.1-3.95,2.45-.02,4.25,1.81,4.22,4.29Z"
            />
            <circle class={classes.cls1} cx="250.73" cy="46.54" r="46.54" />
            <path
              class={classes.cls2}
              d="m78.26,163.48h-32.92c.9-5.55,6.9-10.01,13.1-9.8,1.09.04,2.18.22,3.26.43,1.87.37,2.43-.15,1.99-2.05-.65-2.82-2.5-4.73-5-5.96-5.36-2.62-10.82-2.15-16.22-.15-8.1,2.99-13.53,8.97-17.61,16.31-.6,1.08-1.15,1.39-2.32,1.37-4.95-.07-9.89-.03-14.84-.03-.7-31.26,15.82-79.51,59.14-108.23,45.64-30.26,99.91-28.55,135.6-9.9-4.5,7.19-6.92,14.92-5.39,23.45,1.53,8.47,5.84,15.19,13.34,19.62,11.27,6.66,27.31,4.96,37.72-7.9,1.73,2.58,3.43,5.14,5.15,7.67.39.57.14,1-.12,1.51-9.1,18.38-23.2,31.48-41.91,39.7-1.7.75-3.45,1.37-5.17,2.04-.25.1-.51.16-.7.21-18.92-28.09-43.99-42.1-78.2-33.14-25.81,6.76-48.17,32.53-48.9,64.84Zm93.1-92.95c.01-3.08-2.25-5.47-5.18-5.46-2.72,0-5.12,2.37-5.16,5.09-.05,2.92,2.24,5.35,5.05,5.39,3.08.04,5.27-2.04,5.29-5.01Zm-107.83,43.7c.03-2.48-1.77-4.31-4.22-4.29-2.32.02-4.05,1.68-4.1,3.95-.07,2.66,1.63,4.45,4.22,4.44,2.49,0,4.08-1.59,4.1-4.1Z"
            />
            <path
              class={classes.cls2}
              d="m40.79,254.35c-5.65-6.06-10.44-12.74-14.53-19.93.62-.29,1.24-.57,1.85-.87,12.75-6.23,26.29-9.08,40.41-9.42,11.51-.28,22.65,2.04,33.72,4.85,9.03,2.3,17.95,5.12,27.21,6.43,2.74.39,5.52,1.07,8.33.32,9.41.79,18.69.08,27.71-2.8,16.75-5.35,29.69-15.53,38.46-30.83.97-1.69,1.94-2.36,3.94-2.35,21.81.08,43.63.05,65.44.05.4,0,.81.06,1.48.12-2.48,10.01-6.3,19.34-11.29,28.32-5.28-1.94-10.66-3.2-16.21-3.77-11.3-1.16-22.18.66-32.81,4.42-9.57,3.39-18.31,8.48-27.22,13.23-10.72,5.71-21.79,10.4-33.83,12.62-14.43,2.66-28.59,1.6-42.62-2.41-9.32-2.67-18.36-6.13-27.52-9.25-3.68-1.25-6.01-.46-8.2,2.68-1.97.11-3.96.11-5.92.36-9.9,1.25-19.44,3.74-28.4,8.25Z"
            />
            <path
              class={classes.cls2}
              d="m66.08,276.6c-3.68-2.49-7.28-5.08-10.63-7.99,3.93-2.81,8.54-3.99,13.05-5.32,9.05-2.66,18.35-3.58,27.78-3.38,1.58.03,3.17.47,4.75,0,6.45,1.71,12.83,3.73,19.44,4.78,12.79,2.03,25.56,2.07,38.25-.72,12.81-2.81,24.66-8.06,36.1-14.37,9.37-5.18,18.66-10.56,29.17-13.22,10.29-2.61,20.62-3.01,30.96-.3.98.26,1.94.65,3.2,1.07-3.06,4.54-5.72,9.13-9.28,13.12-6.12-1.15-12.16-.63-18.16.86-10.74,2.67-20.23,8.16-29.77,13.43-9.64,5.32-19.48,10.21-29.99,13.39-15.35,4.65-31.07,7.51-47.24,6.8-4.65-.2-9.32-.58-13.8-1.99-5.68-1.79-11.33-3.67-17.11-5.16-7.1-1.83-14.28-2.69-21.59-2.2-1.73.12-3.59.08-5.13,1.21Z"
            />
            <path
              class={classes.cls4}
              d="m174.36,162.55c.63-5.58,2.29-10.34,5.15-14.19,3.43-4.62,7.54-6.36,12.08-6.36,23.83,0,47.67,0,71.5,0,4.12,0,8.24.06,12.36-.07,1.25-.04,1.76.32,1.95,2.35.39,4.42.88,8.83,1.03,13.29-.24,1.87.21,3.81-.21,5.75-6.09.24-12.12-.07-18.15.36-6.06.43-12.13-.47-18.21-.06-5.4.36-10.83-.18-16.24-.19-4.01-.01-8.02.22-12.04.27-1.49.02-3-.46-4.47-.24-3.76.58-7.53.22-11.29.16-3.99-.06-7.98-.05-11.97-.19-3.37-.12-6.74-.02-10.12-.04-.51,0-1.18.38-1.38-.82Z"
            />
            <path
              class={classes.cls4}
              d="m66.08,276.6c1.53-1.13,3.39-1.09,5.13-1.21,7.31-.49,14.5.36,21.59,2.2,5.78,1.49,11.43,3.37,17.11,5.16,4.48,1.41,9.15,1.79,13.8,1.99,16.16.71,31.88-2.16,47.24-6.8,10.51-3.18,20.35-8.07,29.99-13.39,9.54-5.27,19.03-10.76,29.77-13.43,6-1.49,12.04-2.01,18.16-.86-1.83,2.38-3.97,4.49-5.92,6.74-4.19,4.86-8.88,9.12-13.83,13.14-11.82,9.61-24.97,16.84-39.24,22.13-16.19,5.99-32.92,8.54-50.14,8.22-9.17-.17-18.16-1.68-27.15-3.46-9.32-1.84-17.86-5.7-26.62-9.09-5.49-2.13-10.23-5.57-15.41-8.21-1.56-.8-3.12-1.89-4.49-3.11Z"
            />
            <path
              class={classes.cls4}
              d="m278.44,175.76c-.11,4.26-.59,8.47-.86,12.71-.1,1.58-.8,1.41-1.5,1.41-5.62,0-11.24,0-16.86,0-23.33,0-46.66-.04-69.98.04-4.07.01-7.62-1.49-10.58-5.71-2.06-2.93-3.39-6.42-3.98-10.53,34.54,0,69.08,0,103.64,0,.05.86.09,1.47.13,2.08Z"
            />
            <path
              class={classes.cls4}
              d="m137.78,235.71c-2.81.76-5.59.07-8.33-.32-9.26-1.31-18.18-4.13-27.21-6.43-11.07-2.81-22.21-5.13-33.72-4.85-14.12.34-27.66,3.19-40.41,9.42-.61.3-1.24.58-1.85.87-.98-.27-1.17-1.18-1.55-1.94-4.93-9.97-9.61-20.04-12.69-30.78-.15-.51-.1-1.08-.15-1.62.62-.01,1.24-.03,1.85-.03,23.03,0,46.06-.02,69.1-.03,1.15,0,2.33.09,3.35-.63.89.69,1.34,1.69,1.9,2.63,10.62,17.88,26,29.08,46.5,33.09,1.06.21,2.21,0,3.2.6Z"
            />
            <path
              class={classes.cls5}
              d="m278.44,175.76c-.04-.61-.07-1.22-.13-2.08-34.57,0-69.1,0-103.64,0-.82-3.67-.82-7.38-.31-11.13.2,1.2.87.82,1.38.82,3.37.03,6.75-.07,10.12.04,3.99.14,7.99.12,11.97.19,3.75.06,7.52.42,11.29-.16,1.47-.23,2.98.26,4.47.24,4.01-.05,8.02-.28,12.04-.27,5.41.01,10.84.55,16.24.19,6.08-.4,12.15.5,18.21.06,6.03-.43,12.06-.11,18.15-.36.41-1.95-.03-3.88.21-5.75.51,3.46.25,6.97.23,10.45,0,2.58.31,5.19-.23,7.74Z"
            />
            <path
              class={classes.cls4}
              d="m9.44,189.36c-.95-5.12-1.69-10.27-1.8-15.65h71.05c.66,5.36,1.95,10.53,3.51,15.65-.54.61-1.26.44-1.93.44-22.82.02-45.64.02-68.46.03-.82,0-1.66.1-2.37-.46Z"
            />
            <path
              class={classes.cls5}
              d="m9.44,189.36c.71.57,1.55.46,2.37.46,22.82,0,45.64-.02,68.46-.03.67,0,1.39.17,1.93-.44,1.05,3.46,3.1,6.52,3.99,10.04-1.02.72-2.2.63-3.35.63-23.03.01-46.06.02-69.1.03-.62,0-1.24.02-1.85.03-1.25-3.48-1.81-7.11-2.45-10.72Z"
            />
            <path
              class={classes.cls4}
              d="m101.03,259.9c-1.58.47-3.18.03-4.75,0-9.43-.2-18.73.73-27.78,3.38-4.5,1.32-9.12,2.51-13.05,5.32-5.38-4.25-10.27-9-14.66-14.25,8.96-4.51,18.5-7,28.4-8.25,1.96-.25,3.95-.25,5.92-.36-.3,4.27.71,5.77,4.91,7.03,7.09,2.12,14.1,4.47,21,7.13Z"
            />
            <path
              class={classes.cls1}
              d="m171.35,70.53c-.01,2.98-2.2,5.05-5.29,5.01-2.82-.04-5.1-2.47-5.05-5.39.04-2.72,2.44-5.08,5.16-5.09,2.93,0,5.19,2.37,5.18,5.46Z"
            />
            <path
              class={classes.cls2}
              d="m234.6,54.03c-5.31,3.72-10.5,7.35-15.79,11.05-1.37-1.26-2.34-2.74-3.18-4.4,5.07-3.58,9.98-7.09,14.94-10.52,1.29-.89,1.65-1.79,1.49-3.42-.74-7.49,1.95-13.52,8.53-17.36,6.38-3.73,12.89-3.66,19.21.36,1.03.66,1.99,1.45,2.99,2.19,5.38-3.77,10.74-7.53,16.15-11.32,1.39,1.29,2.24,2.89,3.15,4.56-4.71,3.27-9.31,6.59-14.05,9.7-1.73,1.13-2.14,2.12-1.52,4.18,2.65,8.83-1.37,17.45-9.65,21.21-7.11,3.23-15.34,1.5-20.57-4.31-.53-.6-1.06-1.2-1.7-1.92Z"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}
